export type MemoryCategory =
  | 'language'
  | 'communication-style'
  | 'interest'
  | 'profession'
  | 'ambition'
  | 'relationship-intent'
  | 'friendship-intent'
  | 'professional-intent'
  | 'location-preference'
  | 'recurring-concern'
  | 'life-event'
  | 'hobby'
  | 'boundary'
  | 'other';

export const MEMORY_CATEGORIES: MemoryCategory[] = [
  'language',
  'communication-style',
  'interest',
  'profession',
  'ambition',
  'relationship-intent',
  'friendship-intent',
  'professional-intent',
  'location-preference',
  'recurring-concern',
  'life-event',
  'hobby',
  'boundary',
  'other',
];

export type MemoryStatus = 'suggested' | 'confirmed' | 'rejected';
export type MemorySource = 'user-stated' | 'inferred' | 'onboarding';

/**
 * One item of what Ally knows about the user.
 * Rules:
 * - Explicit stable statements can be stored directly (source 'user-stated').
 * - Repeated inferences are stored with confidence (source 'inferred').
 * - Sensitive or uncertain items stay 'suggested' until the user confirms.
 * - Temporary emotional states are never stored as traits.
 * - The user can inspect, edit and delete everything.
 */
export interface MemoryItem {
  id: string;
  category: MemoryCategory;
  content: string;
  status: MemoryStatus;
  source: MemorySource;
  /** 0..1 */
  confidence: number;
  sensitive: boolean;
  /** Whether the user allows this memory to be used by cloud matching. */
  cloudApproved: boolean;
  createdAtISO: string;
  updatedAtISO: string;
}
